import{a as n}from"./chunk-SOFWXAWE.js";function y(...s){return s.filter(e=>e!=null).reduce((e,r)=>(Object.entries(r).forEach(([o,i])=>{let t=o,c=n(e[t],i);e[t]=c}),e),{})}export{y as a};
